import React, { useState } from 'react';

import { Button, Checkbox, Form } from 'antd';
import { AuthUseCaseInterface } from 'application/usecases/AuthUseCase';
import { UserStorageUseCaseInterface } from 'application/usecases/UserStorageUseCase';
import Logo from 'assets/images/LogoIconAndTextHorizontal.svg';
import { SignUpData } from 'domain/entities/AuthEntity';
import { LINK_URL } from 'infrastructure/config/CONSTANTS';
import { openErrorNoti } from 'presentation/components/Notification';
import { completeFetching, startFetching } from 'presentation/redux/features/app/appSlice';
import { logout } from 'presentation/redux/features/authen/authenSlice';
import { useAppDispatch } from 'presentation/redux/hooks';
import { AUTH_ROUTES } from 'presentation/router/CONSTANTS';
import { useNavigate } from 'react-router-dom';
import { NicknameFormItem } from './components/Nickname';
import { PasswordFormItem } from './components/Password';
import { UsernameFormItem } from './components/Username';

interface props {
    authUseCase: AuthUseCaseInterface;
    userStorage: UserStorageUseCaseInterface;
}

const CU00101Page = ({ authUseCase }: props) => {
    const dispatch = useAppDispatch();
    const navigate = useNavigate();
    const [isDisabled, setIsDisabled] = useState<boolean>(true);
    const [emailErrorMessage, setEmailErrorMessage] = useState<string>('');
    const [passwordErrorMessage, setPasswordErrorMessage] = useState<string>('');
    const [form] = Form.useForm();

    React.useEffect(() => {
        dispatch(logout());
    }, []);

    const submit = async (value: any) => {
        try {
            const payload: SignUpData = {
                email: value.username,
                password: value.password,
                nickName: value.nickName,
            };
            dispatch(startFetching());
            const response = await authUseCase.signup(payload);
            if (response) {
                navigate(
                    AUTH_ROUTES.PATH + '/' + AUTH_ROUTES.SUB.CU_001_02 + '?email=' + value.username,
                    {
                        state: payload,
                    },
                );
            }
        } catch (error: any) {
            if (error.data?.validateEmail || error.data?.validatePassword) {
                setEmailErrorMessage(error.data?.validateEmail);
                setPasswordErrorMessage(error.data?.validatePassword);
            } else {
                setPasswordErrorMessage(error.message);
            }
            openErrorNoti();
        } finally {
            dispatch(completeFetching());
        }
    };

    const gotoTermOfService = (e: any) => {
        //prevent default
        e.preventDefault();
        e.stopPropagation();
        window.open(`${LINK_URL.TERM_OF_SERVICE}`, '_blank', 'noopener,noreferrer');
    };
    
    const gotoTermOfPrivacy = (e: any) => {
        //prevent default
        e.preventDefault();
        e.stopPropagation();
        window.open(`${LINK_URL.TERMS_OF_PRIVACY}`, '_blank', 'noopener,noreferrer');
    };

    return (
        <Form
            className="width-full-screen center-inside CU-001-04-container"
            style={{
                height: '100vh',
            }}
            form={form}
            onFinish={submit}
            onValuesChange={() => {
                setEmailErrorMessage('');
                setPasswordErrorMessage('');
                form.validateFields({ validateOnly: true })
                    .then((values) => {
                        setIsDisabled(!values.aceptTerm);
                        setIsDisabled(!values.aceptTermPrivacy);
                    })
                    .catch((err) => {
                        setIsDisabled(err.errorFields.length > 0 || !err.values.aceptTerm);
                    });
            }}
        >
            <div style={{ width: 343 }}>
                <div
                    className="center-inside center"
                    style={{ borderRadius: 100, backgroundColor: '#fff', width: 160, height: 160 }}
                >
                    <img alt="logo" src={Logo} className='logo'/>
                </div>
                <div
                    className="title"
                    style={{ width: '100%', textAlign: 'center', marginTop: 24, marginBottom: 24 }}
                >
                    アカウント作成
                </div>
                <UsernameFormItem />
                {emailErrorMessage && (
                    <div className="flex relative top-[-20px] h-[5px]">
                        <div
                            id="otp_help"
                            className="ant-form-item-explain ant-form-item-explain-connected"
                            role="alert"
                        >
                            <div className="ant-form-item-explain-error">{emailErrorMessage}</div>
                        </div>
                    </div>
                )}
                <NicknameFormItem />
                <PasswordFormItem />
                {passwordErrorMessage && (
                    <div className="flex relative top-[-20px] h-[5px]">
                        <div
                            id="otp_help"
                            className="ant-form-item-explain ant-form-item-explain-connected"
                            role="alert"
                        >
                            <div className="ant-form-item-explain-error">
                                {passwordErrorMessage}
                            </div>
                        </div>
                    </div>
                )}
                <Form.Item  style={{marginBottom: 0}} name="aceptTerm" label={false} valuePropName="checked" required>
                    <Checkbox>
                        <div>
                            <span className="link" onClick={gotoTermOfService}>
                                利用規約
                            </span>
                            <span className="span">に同意します。</span>
                        </div>
                    </Checkbox>
                </Form.Item>
                <Form.Item name="aceptTermPrivacy" label={false} valuePropName="checked" required>
                    <Checkbox>
                        <div>
                            <span className="link" onClick={gotoTermOfPrivacy}>
                                個人情報の取り扱いについて
                            </span>
                            <span className="span">に同意します。</span>
                        </div>
                    </Checkbox>
                </Form.Item>

                <Button
                    className="button-login-text"
                    type="primary"
                    style={{ width: '100%', height: 56 }}
                    disabled={isDisabled}
                    htmlType="submit"
                >
                    認証コード送信
                </Button>
            </div>
        </Form>
    );
};
export default CU00101Page;
